module.exports = require('react/lib/ReactComponentWithPureRenderMixin');